import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function createMissingAccessVouchers(eventId, values) {
  const { data } = await axios.post(
    `/events/${eventId}/generate-missing-access-voucher-templates`,
    values
  );
  return data;
}

export async function redeemAccessVoucher(registrationId, accessVoucherId) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/access-vouchers/${accessVoucherId}/redeem`
  );
  return data;
}

export async function invalidateAccessVoucher(registrationId, accessVoucherId) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/access-vouchers/${accessVoucherId}/invalidate`
  );
  return data;
}

export async function reprintAccessVoucherWristband(
  registrationId,
  accessVoucherId
) {
  const { data } = await axios.post(
    `/registrations/${registrationId}/access-vouchers/${accessVoucherId}/recreate-wristband`
  );
  return data;
}

export async function redeemAccessVoucherByBarcode(eventId, barcode, values) {
  const { data } = await axios.post(
    `events/${eventId}/redeem-access-voucher/${barcode}`,
    values
  );
  return data;
}

export async function printWristband(wristbandId, values) {
  const { data } = await axios.post(`wristbands/${wristbandId}/print`, values);
  return data;
}

export async function getAccessVouchers(registrationId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `registrations/${registrationId}/access-vouchers?${parameters}`
  );
  return data;
}
